import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './App.css';
import { config } from './config';
import Header from './components/Header';
import Hero from './components/Hero';
import Categories from './components/Categories';
import Footer from './components/Footer';

function App() {
  const [products, setProducts] = useState(null);

  useEffect(() => {
    fetch(`${config.apiUrl}/api/products`)
      .then(res => res.json())
      .then(data => setProducts(data))
      .catch(err => {
        console.error('Error fetching products:', err);
        // Fallback data
        setProducts({
          chaser: [],
          elfliq: [],
          raya: []
        });
      });
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />
      {products && <Categories products={products} />}
      <Footer />
    </div>
  );
}

export default App;

